/* eslint-disable @nx/enforce-module-boundaries */
import moment from 'moment';
import 'moment/min/locales';  // This imports all locales at once
import { useContext, useEffect } from 'react';
import { PostBoxContext } from '../context';
import { Text } from '@mybridge/ui/text';
import { useSelector } from 'react-redux';

const PostTiming = () => {
  const { post } = useContext(PostBoxContext);
  const { type, created_at } = post || {};
  const currentLanguage = useSelector((state) => state.translation.language) || 'en';
  useEffect(() => {
    if (currentLanguage === 'zh-cn') {
      moment.locale('zh-cn'); // Default to Simplified Chinese
    } else {
      moment.locale(currentLanguage);
    }
  }, [currentLanguage]);
  if (type === 2) {
    return (
      <Text fontSize="xs" color="brandGray.700">
        {moment(new Date(created_at)).fromNow()}
      </Text>
    );
  }

  return (
    <Text fontSize="xs" color="brandGray.700">
      {moment(created_at).startOf().fromNow()}
    </Text>
  );
};

export default PostTiming;
